import { BaseExportModal, ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { LODGING_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/Lodging/LodgingColumnsInfo'
import { HOTEL_AMENITIES } from 'constants/hotelAmenities'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startLodgingChainsExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

export default function LodgingExportModal(props: ExportModalProps) {
  const dataTypeName = 'Lodging & Hospitality'
  const { enableLodgingHotelAmenities } = useFeatureFlagService()

  const lodgingColumnHelper = createExportColumnHelper({
    columns: LODGING_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        lodgingColumnHelper.retrieveColumn('name'),
        lodgingColumnHelper.retrieveColumn('city_summary'),
        lodgingColumnHelper.retrieveColumn('state_summary'),
        lodgingColumnHelper.retrieveColumn('zipcode_summary'),
        lodgingColumnHelper.retrieveColumn('domain'),
        lodgingColumnHelper.retrieveColumn('reviews_avg'),
        lodgingColumnHelper.retrieveColumn('reviews_cnt'),
        lodgingColumnHelper.retrieveColumn('open_hours'),
        lodgingColumnHelper.retrieveColumn('doors_cnt'),
      ],
    },
    ...(enableLodgingHotelAmenities
      ? [
          {
            title: 'Hotel Amenities',
            elements: HOTEL_AMENITIES.map((a) => [a.key, `Has ${a.label}`]),
          },
        ]
      : []),
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: `Exporting ${dataTypeName}...` }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startLodgingChainsExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Lodging Opportunities',
    })
  }

  return (
    <BaseExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
